import axios from "axios";
import apiConfig from './api.config';

class RutasDataService {
    getAll() {
        return axios.get(`/rutas?populate=*`, apiConfig.connData());
    }
    getAllRutasItems() {
        return axios.get(`/rutas?populate=*`, apiConfig.connData())
        .then(response => response.data.data)
        .catch(error => {
          console.error("Error al obtener los items:", error);
          throw error;
        });
    }
    get(id) {
        return axios.get(`/rutas/${id}?populate[Parada][populate]=*&populate[Imagen][populate]&populate[gpx][populate]&populate[[item_pdi][populate]=*`, apiConfig.connData());
    }
}
export default new RutasDataService();